import { createSelector } from 'reselect';
import _ from 'lodash';

const _scopedState = (state) => _.get(state, 'entities.accountTemplate', {});

const _accountTemplatesById = (state) => {
  return _scopedState(state).byId;
};

const isFetching = (state) => _scopedState(state).isFetching;
const isEmpty = createSelector([_accountTemplatesById], (templates) => _.isEmpty(templates));

const accountTemplates = createSelector([_accountTemplatesById], (templates) => {
  return _.values(templates);
});

const accountTemplateById = createSelector(
  [_accountTemplatesById, (state, templateId) => templateId],
  (templates, templateId) => templates[templateId]
);

const sortedAccountTemplates = createSelector(
  [accountTemplates, (state, sort) => sort, (state, sort, dir = 'desc') => dir],
  (templates, sort, dir) => {
    return _.orderBy(templates, sort, dir);
  }
);

const lastQuery = (state) => _scopedState(state).lastQuery;

export default {
  accountTemplates,
  accountTemplateById,
  sortedAccountTemplates,
  isFetching,
  isEmpty,
  lastQuery,
};
